import { render, staticRenderFns } from "./FilesToolbar.vue?vue&type=template&id=3d0ba285&"
import script from "./FilesToolbar.vue?vue&type=script&lang=js&"
export * from "./FilesToolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FilesToolbar.vue"
export default component.exports